import React from "react";

interface IProps {
  width?: string;
  height?: string;
  className?: string;
}

const EASkeletonLoader: React.FC<IProps> = ({ width = "100%", height = "100%", className = "" }) => {
  return (
    <div
      className={`skeleton-loader ${className}`}
      style={{
        width,
        height,
      }}
    />
  );
};

export default EASkeletonLoader;
